<template>
  <div class="modal_json">
    <pre>
      {{ JSON.parse(data) }}
    </pre>
    <div class="text-center">
      <button
        type="submit"
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        Close
      </button>
    </div>
  </div>

</template>
<script>

export default {
  props: ['data'],

  data () {
    return {
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
  }
}

</script>

<style lang='scss'>
  .modal_json{
    padding: 10px;
    pre{
      max-height: 500px
    }
  }

</style>
